import React from "react";
import "../../../index.css";
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

import "../home/home.css";
import {getCards} from "../HomeCards";
import Box from "@mui/material/Box";
import DataInfo from "./DataInfo";
const config = window.config;


function YouDataManagement(props) {


    return (
        <React.Fragment>
            <div className="home">
               <div className={"home_title"}>
                    <Typography variant={"h4"}>Welcome to your Data Management Dashboard</Typography>
                    <Typography variant={"h6"}>What are you up to, today?</Typography>
                <div className="boxStart">
                    <Grid container justifyContent="center" spacing={2}>
                        {getCards()}
                    </Grid>
                    <Grid item lg={12}>
                        <Box p={4}>
                            <hr className="yellowDivider"/>
                            <DataInfo/>
                        </Box>
                    </Grid>
                </div>
               </div>
            </div>
        </React.Fragment>
    );
}

export default YouDataManagement;
